<template>
  <div :class="$route.name" class="h-full">
    <router-view :key="$route.meta.section || 'unknown-section'" />
    <teleport to="#model-outlet"></teleport>
    <portal-target name="model-outlet"></portal-target>

    <!-- import primevue components to properly load their styles -->
    <Select class="!hidden" />
  </div>
</template>

<script lang="ts">
  import { Loader } from "@/components/forms";
  import { setGlobalDateI18n } from "fecha";
  import nl from "@vee-validate/i18n/dist/locale/nl.json";
  import { localize } from "@vee-validate/i18n";
  import { computed } from "vue";
  import { PortalTarget } from "portal-vue";
  import Select from "primevue/select";
  import { setLocale } from "yup";
  localize("nl", nl);
  setLocale({
    mixed: {
      required: "Vereist",
    },
  });

  export default {
    components: {
      Loader,
      PortalTarget,
      Select,
    },
    data() {
      return {
        breakpoints: ["xs"],
      };
    },
    computed: {
      clientWidth() {
        return window.outerWidth;
      },
      isMobile() {
        return this.breakpoints.includes("xs") && !this.breakpoints.includes("md") && !this.breakpoints.includes("xl");
      },
      mediaQuery() {
        const breakpoints = this.breakpoints;
        if (breakpoints.includes("4xl")) {
          return "4xl";
        } else if (breakpoints.includes("3xl")) {
          return "3xl";
        } else if (breakpoints.includes("2xl")) {
          return "2xl";
        } else if (breakpoints.includes("xl")) {
          return "xl";
        } else if (breakpoints.includes("lg")) {
          return "lg";
        } else if (breakpoints.includes("md")) {
          return "md";
        } else if (breakpoints.includes("sm")) {
          return "sm";
        } else if (breakpoints.includes("xs")) {
          return "xs";
        }
      },
      isTablet() {
        return this.breakpoints.includes("xs") && !this.breakpoints.includes("lg");
      },
      isDesktop() {
        return this.breakpoints.includes("xl");
      },
      isFullScreenApp() {
        // @ts-ignore - Fix for standalone property on navigator
        return window.navigator.standalone;
      },
      isProd() {
        return import.meta.env.NODE_ENV === "production";
      },
    },
    provide() {
      return {
        isDesktop: computed(() => this.isDesktop),
        isMobile: computed(() => this.isMobile),
        isTablet: computed(() => this.isTablet),
      };
    },
    created() {
      setGlobalDateI18n({
        dayNames: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"],
        monthNames: ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"],
      });
    },
    mounted() {
      // Create a div for teleport target if it doesn't exist
      if (!document.getElementById("model-outlet")) {
        const modelOutlet = document.createElement("div");
        modelOutlet.id = "model-outlet";
        document.body.appendChild(modelOutlet);
      }

      this.setVh();
      this.initViewport();
      window.addEventListener("resize", this.setVh);
      window.addEventListener("orientationchange", this.setVh);
      window.addEventListener("resize", this.initViewport);
      window.addEventListener("orientationchange", this.initViewport);
    },
    methods: {
      setVh() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
      },
      initViewport() {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);

        if (window.innerWidth < 576) {
          this.breakpoints = ["xs"];
        }
        if (window.innerWidth >= 576) {
          this.breakpoints = ["xs", "sm"];
        }
        if (window.innerWidth >= 768) {
          this.breakpoints = ["xs", "sm", "md"];
        }
        if (window.innerWidth >= 1024) {
          this.breakpoints = ["xs", "sm", "md", "lg"];
        }
        if (window.innerWidth >= 1280) {
          this.breakpoints = ["xs", "sm", "md", "lg", "xl"];
        }
        if (window.innerWidth >= 1536) {
          this.breakpoints = ["xs", "sm", "md", "lg", "xl", "2xl"];
        }
        if (window.innerWidth >= 1800) {
          this.breakpoints = ["xs", "sm", "md", "lg", "xl", "2xl", "3xl"];
        }
        if (window.innerWidth >= 2100) {
          this.breakpoints = ["xs", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl"];
        }
      },
    },
  };
</script>
